export const timeToSeconds = (time:string) => {
    const parts = time.split(':').map(Number);
    if (parts.length === 2) {
        return parts[0] * 60 + parts[1];
    }
    if (parts.length === 3) {
        return parts[0] * 3600 + parts[1] * 60 + parts[2];
    }
    return 0;
};

export interface SipUriParts {
    user: string;
    host: string;
    port: string;
}

export function parseSipUri(sipUri: string): SipUriParts | null {
    const match = sipUri.match(/^([^@]+)@([^:]+):(.+)$/);
    if (!match ) return null;
    return {
        user: match[1],
        host: match[2],
        port: match[3],
    };
}